module.exports = __webpack_public_path__ + "img/news-historical-02.jpg?ecf1bdd3603f6290428a0aa3468eacc5";